module.exports = __webpack_public_path__ + "img/BC.06a0c954.png";